import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
// import { AuthEffects } from 'auth'
import { NgModule } from '@angular/core';
// import { StoreModule } from '@ngrx/store';
// import { reducers } from './core/app.states';
// import { EffectsModule } from '@ngrx/effects';
import { AppRoutingModule } from './app-routing-module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SampleEffects } from './sample/store/sample.effects';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ClaimCmeCeModule } from './components/claim-cme-ce/claim-cme-ce.module';

import { FakeStoreComponent } from './components/fake-store/fake-store.component';
import { AuthGuardService as AuthGuard } from './auth/services/auth-guard.service';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [AppComponent, FakeStoreComponent],
  imports: [
    CommonModule,
    ClaimCmeCeModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    SharedModule,
    // StoreModule.forRoot(reducers),
    // EffectsModule.forRoot([AuthEffects, SampleEffects]),
    AppRoutingModule,
  ],
  exports: [],
  providers: [CookieService, AuthGuard],
  bootstrap: [AppComponent],
})
export class AppModule {}
